import React, { useState } from "react";
import "./Answers.css";
import Main from "./Main";

function Answers() {
  const [userInput, setUserInput] = useState("");
  const [randomIndex, setRandomIndex] = useState(null);
  const [error, setError] = useState("");

  const handleChange = (event) => {
    setUserInput(event.target.value);
  };

  const handleClick = () => {
    if (userInput.trim()) {
      setError("");
      setRandomIndex(Math.floor(Math.random() * possibleAnswers.length));
      setUserInput("");
    } else {
      setError("Please ask a question first...");
      setRandomIndex(null);
    }
  };

  const possibleAnswers = [
    "I cannot answer that now.",
    "Dare to dream!",
    "It is certain.",
    "Don't count on it.",
    "It is decidedly so!",
    "A miracle is on its way!",
    "Follow your heart!",
    "Appreciate present blessings.",
    "Listen to your intuition!",
    "Outlook not so good.",
    "Signs point to yes.",
    "Only time will tell.",
    "It's time to let go.",
    "It is time to act.",
    "You are divinely guided.",
    "Keep your guard up!",
    "All is an illusion.",
    "Give yourself time to heal.",
    "The answer is no.",
    "It is never too late.",
  ];

  const answer = randomIndex !== null ? possibleAnswers[randomIndex] : "";

  return (
    <div className="Answers">
      <h1 className="main-title">Let the Universe Guide You</h1>
      <p className="sub-instruction">
        Type to ask the Magic Crystal Ball a question!
      </p>

      <input
        type="text"
        className="question-input"
        placeholder="Type your question here..."
        value={userInput}
        onChange={handleChange}
      />

      <div className="crystal-ball-container" onClick={handleClick}>
        <Main />
        <div className="overlay-content">
          {error ? (
            <p className="answer-text">{error}</p>
          ) : (
            <p className="answer-text">{answer}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Answers;
